module.exports = __webpack_public_path__ + "static/media/gopuram.012ce889.svg";